import React from 'react';
import { Heading, Section, Tile } from '@carbon/react';
import { Document } from '@carbon/icons-react';
import PageContainer from '../components/PageContainer';

const Reports = () => {
  return (
    <PageContainer>
      <Section>
        <Heading style={{ marginBottom: '2rem' }}>
          <Document size={32} style={{ marginRight: '1rem', verticalAlign: 'middle' }} />
          Reports
        </Heading>
        <div style={{ display: 'grid', gap: '1rem' }}>
          <Tile>
            <h4>Monthly Revenue Report</h4>
            <p>Generated on Oct 29, 2025</p>
          </Tile>
          <Tile>
            <h4>User Activity Report</h4>
            <p>Generated on Oct 28, 2025</p>
          </Tile>
          <Tile>
            <h4>System Performance Report</h4>
            <p>Generated on Oct 27, 2025</p>
          </Tile>
        </div>
      </Section>
    </PageContainer>
  );
};

export default Reports;
